/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ngx-gallery-preview.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from 'ngx-gallery/lib/ngx-gallery-preview.component';
import * as i3 from './ngx-gallery-arrows.component.ngfactory';
import * as i4 from 'ngx-gallery/lib/ngx-gallery-arrows.component';
import * as i5 from '@angular/common';
import * as i6 from 'ngx-gallery/lib/ngx-gallery-helper.service';
const styles_NgxGalleryPreviewComponent:any[] = [i0.styles];
export const RenderType_NgxGalleryPreviewComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_NgxGalleryPreviewComponent,data:{}});
function View_NgxGalleryPreviewComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'i',[['aria-hidden',
      'true']],[[8,'className',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.manageFullscreen()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i1.ɵinlineInterpolate(1,'ngx-gallery-icon ngx-gallery-fullscreen ',
        _co.fullscreenIcon,'');
    _ck(_v,0,0,currVal_0);
  });
}
function View_NgxGalleryPreviewComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'ngx-gallery-preview-text']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.description;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_NgxGalleryPreviewComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-arrows',
      ([] as any[]),(null as any),[[(null as any),'onPrevClick'],[(null as any),'onNextClick']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.NgxGalleryPreviewComponent = _v.component;
        if (('onPrevClick' === en)) {
          const pd_0:any = ((<any>_co.showPrev()) !== false);
          ad = (pd_0 && ad);
        }
        if (('onNextClick' === en)) {
          const pd_1:any = ((<any>_co.showNext()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_NgxGalleryArrowsComponent_0,i3.RenderType_NgxGalleryArrowsComponent)),
      i1.ɵdid(49152,(null as any),0,i4.NgxGalleryArrowsComponent,([] as any[]),{prevDisabled:[0,
          'prevDisabled'],nextDisabled:[1,'nextDisabled'],arrowPrevIcon:[2,'arrowPrevIcon'],
          arrowNextIcon:[3,'arrowNextIcon']},{onPrevClick:'onPrevClick',onNextClick:'onNextClick'}),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          0,'i',[['aria-hidden','true']],[[8,'className',0]],[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.NgxGalleryPreviewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.close()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgxGalleryPreviewComponent_1)),
      i1.ɵdid(16384,(null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),3,'div',[['class','ngx-spinner-wrapper ngx-gallery-center']],
          [[2,'ngx-gallery-active',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),0,'i',[['aria-hidden','true']],[[8,'className',
              0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),
          i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),9,'div',[['class','ngx-gallery-preview-wrapper']],
              (null as any),[[(null as any),'click']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:i2.NgxGalleryPreviewComponent = _v.component;
                if (('click' === en)) {
                  const pd_0:any = ((<any>(_co.closeOnClick && _co.close())) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),3,'div',[['class','ngx-gallery-preview-img-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),0,'img',[['class','ngx-gallery-preview-img ngx-gallery-center']],
          [[8,'src',4],[2,'ngx-gallery-active',(null as any)]],[[(null as any),'load'],
              [(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.NgxGalleryPreviewComponent = _v.component;
            if (('load' === en)) {
              const pd_0:any = ((<any>_co.loaded()) !== false);
              ad = (pd_0 && ad);
            }
            if (('click' === en)) {
              const pd_1:any = ((<any>$event.stopPropagation()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),
      (_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NgxGalleryPreviewComponent_2)),i1.ɵdid(16384,
          (null as any),0,i5.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i2.NgxGalleryPreviewComponent = _v.component;
    const currVal_0:boolean = !_co.canShowPrev();
    const currVal_1:boolean = !_co.canShowNext();
    const currVal_2:any = _co.arrowPrevIcon;
    const currVal_3:any = _co.arrowNextIcon;
    _ck(_v,1,0,currVal_0,currVal_1,currVal_2,currVal_3);
    const currVal_5:any = _co.fullscreen;
    _ck(_v,6,0,currVal_5);
    const currVal_10:any = (_co.showDescription && _co.description);
    _ck(_v,21,0,currVal_10);
  },(_ck,_v) => {
    var _co:i2.NgxGalleryPreviewComponent = _v.component;
    const currVal_4:any = i1.ɵinlineInterpolate(1,'ngx-gallery-icon ngx-gallery-close ',
        _co.closeIcon,'');
    _ck(_v,3,0,currVal_4);
    const currVal_6:any = _co.showSpinner;
    _ck(_v,8,0,currVal_6);
    const currVal_7:any = i1.ɵinlineInterpolate(1,'ngx-gallery-icon ngx-gallery-spinner ',
        _co.spinnerIcon,'');
    _ck(_v,10,0,currVal_7);
    const currVal_8:any = (_co.src? _co.src: '#');
    const currVal_9:boolean = !_co.showSpinner;
    _ck(_v,17,0,currVal_8,currVal_9);
  });
}
export function View_NgxGalleryPreviewComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'ngx-gallery-preview',
      ([] as any[]),(null as any),[['window','keydown']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:keydown' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onKeyDown($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_NgxGalleryPreviewComponent_0,RenderType_NgxGalleryPreviewComponent)),
      i1.ɵdid(573440,(null as any),0,i2.NgxGalleryPreviewComponent,[i1.ElementRef,
          i6.NgxGalleryHelperService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const NgxGalleryPreviewComponentNgFactory:i1.ComponentFactory<i2.NgxGalleryPreviewComponent> = i1.ɵccf('ngx-gallery-preview',
    i2.NgxGalleryPreviewComponent,View_NgxGalleryPreviewComponent_Host_0,{images:'images',
        descriptions:'descriptions',showDescription:'showDescription',swipe:'swipe',
        fullscreen:'fullscreen',forceFullscreen:'forceFullscreen',closeOnClick:'closeOnClick',
        closeOnEsc:'closeOnEsc',keyboardNavigation:'keyboardNavigation',arrowPrevIcon:'arrowPrevIcon',
        arrowNextIcon:'arrowNextIcon',closeIcon:'closeIcon',fullscreenIcon:'fullscreenIcon',
        spinnerIcon:'spinnerIcon'},{onClose:'onClose'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/ngx-gallery/lib/ngx-gallery-preview.component.ngfactory.ts